export enum Status {
    DRAFT = 'DRAFT',
    SUBMITTED = 'SUBMITTED',
}